import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { uploadImageApi } from "../../setting/uploadImage/uploadImageAction";
import { GetInsuranceServiceData, AddInsuranceDeliveryPassApi } from "./insuranceServiceAction";
import { useTranslation } from "react-i18next";
import { setHeading } from "../../../accounts/account.actions";
import _ from "lodash";
import Spinner from "react-bootstrap/Spinner";
import Select from "react-select";
import Swal from "sweetalert";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import ImageUploader from "react-images-upload";
import '../../../../../il8n';


const AddGatePass = (props) => {
    const { t, i18n } = useTranslation();
    // const [ownerName, setOwnerName] = useState();
    const [residenceID, setResidenceID] = useState();
    const [reciverName, setReceiverName] = useState();
    // const [contactNumber, setContactNumber] = useState();
    const [remarks, setRemarks] = useState();
    const [deliverDate, setDeliverDate] = useState();
    const [insuranceServiceId, setinsuranceServiceId] = useState();
    const [mainServiceName, setMainServiceName] = useState();
    const [vehicleKilometer, setVehicleKilometer] = useState();
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


    const handleVisible = (msg) => {
        setAlertVisible(true);
        setTimeout(() => {
            setAlertVisible(false);
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            button: "Ok",
        });
    };
    const handleDangerVisible = (err) => {
        setDangerVisibleAlert(true);
        setTimeout(() => {
            setDangerVisibleAlert(false);
        }, 9000);
        Swal({
            title: "Error",
            text: err,
            icon: "error",
            button: "Ok",
        });
    };
    function DeliveryPass() {
        props.AddInsuranceDeliveryPassApi({
            insuranceServiceId: insuranceServiceId,
            ownerName: GetServiceInfo.customerName,
            residenceID: residenceID,
            reciverName: reciverName,
            contactNumber: GetServiceInfo.customerNumber,
            remarks: remarks,
            deliverDate: deliverDate,
            vehicleKilometer: vehicleKilometer,
            feeds: props.UploadImageURL,
        },
            handleVisible,
            handleDangerVisible
        );
        // setOwnerName("")
        setResidenceID("")
        setReceiverName("")
        // setContactNumber("")
        setRemarks("")
        setDeliverDate("")
        setinsuranceServiceId("")
        setVehicleKilometer("")
    }

    const GetServiceInfo = !_.isEmpty(insuranceServiceId) && _.find(props.insuranceServiceDataList, (x) => x._id === insuranceServiceId);

    const onDrop = (pictureFiles) => {
        props.uploadImageApi({
            image: pictureFiles[pictureFiles.length - 1],
        });
    };

    const handleChangeMainService = (selectedOption) => {
        setinsuranceServiceId(selectedOption.value);
        setMainServiceName(selectedOption.label);
    };
    const filterService = _.filter(props.insuranceServiceDataList, { status: 'Completed' }).sort((a, b) => b.seqNumber - a.seqNumber)
    const getMainServiceList = !_.isEmpty(filterService) && filterService.map((x) => {
        let data = { value: x._id, label: `${x.seqNumber} / ${x.vehicleNumber} / ${x.vehicleMade} / ${x.customerName}` };
        return data;
    });

    useEffect(() => {
        props.setHeading("Delivery Pass");
        props.GetInsuranceServiceData()
    }, []);

    return (<>
        {props.isAddingInsuranceDeliveryPass || props.isFetchingInsuranceService ? (
            <div className="loader-div">
                <Spinner
                    variant="primary"
                    animation="border"
                    size="xl"
                    role="status"
                    aria-hidden="true"
                />
            </div>
        ) : (
            <Container fluid>
                <div className="main">
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('SelectService')} *</b> </Form.Label>
                                <Select
                                    isDisabled={_.isEmpty(filterService)}
                                    placeholder="Select Service"
                                    onChange={handleChangeMainService}
                                    options={getMainServiceList}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('OwnerName')}</b></Form.Label>
                                <Form.Control
                                    disabled
                                    type="text"
                                    placeholder="Owner Name"
                                    value={GetServiceInfo === false ? '' : GetServiceInfo.customerName}
                                // onChange={(e) => setOwnerName(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('ContactNumber')}</b></Form.Label>
                                <Form.Control
                                    disabled
                                    type="number"
                                    placeholder="Contact Number"
                                    value={GetServiceInfo === false ? '' : GetServiceInfo.customerNumber}
                                // onChange={(e) => setContactNumber(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('ResidenceID')}*</b> </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Residence ID"
                                    onChange={(e) => setResidenceID(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('ReceiverName')} *</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Receiver Name"
                                    onChange={(e) => setReceiverName(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('DeliveryDate')} </b> </Form.Label>
                                <Form.Control
                                    type="date"
                                    placeholder="Delivery Date"
                                    onChange={(e) => setDeliverDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('VehicleKilometer')} </b></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Vehicle Kilometer"
                                    onChange={(e) => setVehicleKilometer(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>{t('Remarks')} </b></Form.Label>
                                <Form.Control
                                    type="text"
                                    as='textarea'
                                    rows={3}
                                    placeholder="Remarks"
                                    onChange={(e) => setRemarks(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label> <b style={{ fontSize: "large" }}> {t('UploadImages')} </b> </Form.Label>
                                <ImageUploader
                                    withIcon={false}
                                    buttonText="Upload Images"
                                    onChange={onDrop}
                                    // onChange = {(e) => setUploadCnicImage(e.target.files[0])}
                                    imgExtension={[".jpg", ".jpeg", ".png"]}
                                    maxFileSize={999999999999999999999}
                                    singleImage={false}
                                    withPreview={true}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div style={{ marginTop: '20px', textAlign: 'center' }}>
                        {_.isEmpty(mainServiceName) || _.isEmpty(residenceID) || _.isEmpty(reciverName) ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={DeliveryPass}> SAVE </Button>
                        )}
                    </div>

                </div>
            </Container>
        )}
    </>)
}

const mapDispatchToProps = (dispatch) => {
    return {
        AddInsuranceDeliveryPassApi: (data, handleVisible, handleDangerVisible) => dispatch(AddInsuranceDeliveryPassApi(data, handleVisible, handleDangerVisible)),
        GetInsuranceServiceData: () => dispatch(GetInsuranceServiceData()),
        uploadImageApi: (data) => dispatch(uploadImageApi(data)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingInsuranceDeliveryPass: state.InsuranceServiceReducer.isAddingInsuranceDeliveryPass,
    insuranceServiceDataList: state.InsuranceServiceReducer.insuranceServiceDataList,
    isFetchingInsuranceService: state.InsuranceServiceReducer.isFetchingInsuranceService,
    UploadImageURL: state.UploadImageReducer.UploadImageURL,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddGatePass);